export enum METADATA_KEY_VALUES {
  EQUALS = 'equalsValues',
  EXIST = 'exist',
  IN = 'inValues',
  NOT_EQUALS = 'notEqualsValues',
  NOT_EXIST = 'notExist',
  NOT_IN = 'notInValues',
}

export const METADATA_OPTIONS = [
  {
    label: 'common.metadata.keys.exist',
    value: METADATA_KEY_VALUES.EXIST,
  },
  {
    label: 'common.metadata.keys.notExist',
    value: METADATA_KEY_VALUES.NOT_EXIST,
  },
  {
    label: 'common.metadata.keys.equalsValues',
    value: METADATA_KEY_VALUES.EQUALS,
  },
  {
    label: 'common.metadata.keys.notEqualsValues',
    value: METADATA_KEY_VALUES.NOT_EQUALS,
  },
  {
    label: 'common.metadata.keys.inValues',
    value: METADATA_KEY_VALUES.IN,
  },
  {
    label: 'common.metadata.keys.notInValues',
    value: METADATA_KEY_VALUES.NOT_IN,
  },
];

export const nullableMetadata = {
  key: null,
  operation: METADATA_KEY_VALUES.EQUALS,
  useTemplate: false,
  value: null,
};
